import {V2RequestsFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import {ActionOrigin} from 'constants/AnalyticsConstants';
import makeSimpleActionFunction from 'notebook/structured-tables/action-functions/makeSimpleActionFunction';
import {
  StructuredTableKind,
  TableActionFunctionParameters,
} from 'notebook/structured-tables/StructuredTableConstants';
import {trackCreateRequestV2SubmissionShortcutOpened} from 'processes/requests_v2/dashboard/CreateRequestV2SubmissionShortcutButton';
import QueryingCreateRequestV2SubmissionModal from 'processes/requests_v2/modals/CreateRequestV2SubmissionModal';
import runModal from 'ui-library/runModal';

function openRequestV2CreationModalWithSeedData<TTableMetadata, TRowMetadata>({
  structuredTable,
  computedTable,
}: TableActionFunctionParameters<TTableMetadata, TRowMetadata>): void {
  runModal(QueryingCreateRequestV2SubmissionModal, {
    requestSeedData: {structuredTable, computedTable},
    actionOrigin: ActionOrigin.NOTEBOOK_UNDETERMINED_STRUCTURED_TABLE,
  });
  trackCreateRequestV2SubmissionShortcutOpened(ActionOrigin.NOTEBOOK_UNDETERMINED_STRUCTURED_TABLE);
}

export const createRequestV2SubmissionActionFunction = makeSimpleActionFunction({
  label: 'Create request',
  icon: 'request_v2_submission',
  onInvoke: openRequestV2CreationModalWithSeedData,
  getDisabled: ({structuredTable}) =>
    structuredTable.isConfig ||
    (structuredTable.kind !== StructuredTableKind.LOOKUP &&
      !structuredTable.rows.some((row) => row.isFinalized)),
  getHidden: () =>
    !BenchlingConfig.REQUESTS_V2_ENABLE || !isFeatureEnabled({feature: V2RequestsFeature.V2_REQUESTS_CREATE}),
});
